import { isEqual, keys } from 'lodash';
import { ChangeDetectionStrategy, Component, forwardRef, OnInit, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { untilDestroy } from '@ngrx-utils/store';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-age-form-field',
  templateUrl: './age-form-field.component.html',
  styleUrls: ['./age-form-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AgeFormFieldComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgeFormFieldComponent implements OnInit, OnDestroy {

  form = this.getForm();

  constructor(
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.form.valueChanges.pipe(
      distinctUntilChanged(isEqual),
      filter(value => this.form.valid),
      map(value => this.getDateFromForm(value)),
      untilDestroy(this)
    ).subscribe(value => this.onChange(value));
  }

  ngOnDestroy(): void { }

  writeValue(birthDate: any): void {
    if (birthDate) {
      const ageObject = this.getAgeObjectFromDate(birthDate.toDate());
      this.form.patchValue(ageObject);
    }
  }

  onChange = (_) => { };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  private getForm(): FormGroup {
    return this.formBuilder.group({
      years: [null, Validators.min(0)],
      months: [null, Validators.min(0)],
      days: [null, Validators.min(0)]
    });
  }

  private getDateObject(value: any): any {
    return {
      ...value?.years ? { years: value.years } : {},
      ...value?.months ? { months: value.months } : {},
      ...value?.days ? { days: value.days } : {},
    };
  }

  private getAgeObjectFromDate(birthDate: any): any {
    const d1 = DateTime.local();
    const d2 = DateTime.fromJSDate(birthDate);
    return d1.diff(d2, ['years', 'months', 'days', 'hours']).toObject();
  }

  private getDateFromForm(value: any): Date | null {
    const dateObject = this.getDateObject(value);
    if (!keys(dateObject).length) {
      return null;
    }
    return DateTime.local().minus(dateObject).toJSDate();
  }

}
